import { IonIcon, IonModal } from "@ionic/react";
import React, { useEffect, useState } from "react";

import EMSAlertList from "../EMSAlertList/EMSAlertList";
import "./PatientAlert.scss";
import { close } from "ionicons/icons";
import { CONSTANTS } from "../../../constants/callcentral.constants";

interface ContainerProps {
  showPatientAlert: boolean;
  showAlert: () => void;
  patientInputParams: any;
  isFromRejectStatus?: any;
}
const PatientAlert: React.FC<ContainerProps> = (props: any) => {
  const [showModalAlert, setShowModalAlert] = useState(false);
  const [incomingPatientsListData, setIncomingPatientsListData]: any =
    useState();
  const [audio, setAudio] = useState(new Audio(CONSTANTS.ALERT_RINGTONE.ALERT));

  useEffect(() => {
    if (props.showPatientAlert) {
      displayPatientAlert();
      setIncomingPatientsListData(props.patientInputParams);
    }
  }, [props.patientInputParams]);

  const displayPatientAlert = () => {
    setShowModalAlert(true);
    audio.load();
    audio.loop = true;
    audio.play();
  };

  const closePopupModal = () => {
    setShowModalAlert(false);
    props.showAlert();
    audio.load();
    audio.loop = false;
    audio.pause();
  };

  const updatedList = (ems_id: any) => {
    if (ems_id) {
      props.patientInputParams.splice(
        props.patientInputParams.findIndex(function (i: any) {
          return i.ems_source_id === ems_id;
        }),
        1
      );
      setIncomingPatientsListData(props.patientInputParams);
      setModalPopupStatus(props.patientInputParams.length);
    }
  };

  const setModalPopupStatus = (list_length: any) => {
    if (list_length == 0) {
      setShowModalAlert(false);
    }
  };

  const updateAlertHeight = () => {
    if (incomingPatientsListData?.length >= 2) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <IonModal
      isOpen={showModalAlert}
      className={`ems-patient-alert-modal ${
        updateAlertHeight() ? "adjust-height" : ""
      }`}
      backdropDismiss={false}
    >
      <div className="alert-ems-main-container">
        <div
          className="close-icon-attachment"
          onClick={closePopupModal}
        >
          <IonIcon icon={close}></IonIcon>
        </div>
        <div className="content-area">
          <h3 className="label">
            {props.isFromRejectStatus
              ? "Rejected patients alert"
              : "EMS Patients Alert"}
          </h3>
          <div className="ems-alert-list-container">
            {incomingPatientsListData &&
              incomingPatientsListData.map((patientData: any) => {
                return (
                  <EMSAlertList
                    incomingPatientsListData={incomingPatientsListData}
                    audio={audio}
                    patientInputParams={patientData}
                    updateList={updatedList}
                    isFromRejectStatus={props.isFromRejectStatus}
                  ></EMSAlertList>
                );
              })}
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default PatientAlert;
